import Toastr from "../../../itrust_common/components/Toastr"

const PARENT = 'MARKETING_BLAST_'

const DEFAULT_STATE = {
  kpis: {},
  graphs: {},
  loading: false,
}
let changes = null;
export default function reportsReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${PARENT}DASHBOARD_LOAD_PENDING`:
      return { ...state, loading: true };

    case `${PARENT}DASHBOARD_LOAD_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        loading: false,
      }
      return { ...state, ...changes };

    case `${PARENT}DASHBOARD_LOAD_FULFILLED`:
      changes = {
        loading: false,
        ...response
      }
      return { ...state, ...changes };

    default:
      return state;
  }
}